import { Dialog, DialogContent, TextField } from "@mui/material"
import { BoxFR } from "components/BoxCustom"
import ComboBox from "components/ComboBox"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { jobOrderApiNm } from "constants/jobOrderConstant"
import { subcontractApiNm } from "constants/subcontractConstant"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"

const initData = {
    ScId: null,
    JobOrdId: ""
  }
const LinkIdDialog = ({ jobOrdId, dialogOpen, setDialogOpen, onFinish }) => {

  const { ax } = useContext(GlobalStateContext)
  const [scCombo, setScCombo] = useState([])
  const [dialogData, setDialogData] = useState(initData)

  const handleDialogOk = useCallback(() => {
    if (!dialogData.ScId || !dialogData.JobOrdId) {
      return
    }
    const linkSiteAbbr = scCombo.find(item => item.id === dialogData.ScId)?.LnkSiteAbbr
    const postData = {
      JobOrdId: jobOrdId,
      LnkId: dialogData.JobOrdId,
      LnkSiteAbbr: linkSiteAbbr
    }
    ax.post(jobOrderApiNm.linkId, postData).then(value => {
      if (value.data) {
        setDialogOpen(false)
        onFinish()
      }
    })
  }, [dialogData, ax, jobOrdId, onFinish, scCombo, setDialogOpen])

  useEffect(() => {
    if (dialogOpen) {
      ax.post(subcontractApiNm.getSubcontract, {}).then(value => {
        if (value.data) {
          const scData = value.data.filter(item => item.LnkSiteAbbr).map(item => ({
            id: item.ScId,
            label: item.Name,
            LnkSiteAbbr: item.LnkSiteAbbr
          }))
          setScCombo(scData)
          if (scData.length > 0) {
            setDialogData(o => ({ ...o, ScId: scData[0].id }))
          }
        }
      })
    } else {
      setDialogData(initData)
    }
  }, [dialogOpen, ax])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='sm'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ข้อมูลเชื่อมโยงใบงาน"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFR pt={2} justifyContent="center" >
          <ComboBox sx={{ width: 250 }} options={scCombo} label="รถร่วมใช้ Emily"
            selectedId={dialogData.ScId} required={true}
            setSelectedId={(id) => setDialogData(o => ({ ...o, ScId: id }))}
          />
          <TextField label="เลขที่ใบงานรถร่วม" value={dialogData.JobOrdId}
            size="small"
            onChange={(e) => setDialogData(o => ({ ...o, JobOrdId: e.target.value }))}
            sx={{ width: 180 }} required={true} error={!dialogData.JobOrdId} />
        </BoxFR>
      </DialogContent>
      <DialogFooter okText={"บันทึก"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(LinkIdDialog)